import { render, staticRenderFns } from "./brand-grid.vue?vue&type=template&id=2957fe45"
import script from "./brand-grid.vue?vue&type=script&lang=js"
export * from "./brand-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports